import { React } from "react";
import { BrowserRouter } from "react-router-dom";
import { createRoot } from "react-dom/client";
import App from "App";

const container = document.getElementById("root");
const root = createRoot(container);

// Wraps content and initiates APP
root.render(
  <BrowserRouter>
    <App document={document} />
  </BrowserRouter>
);
